/* Hush — Coffee page v2 behavior.
   Three small jobs, all optional and all motion-safe:
   1. Scroll-linked bag tilt (subtle; skipped for prefers-reduced-motion).
   2. Tasting-note polaroids slide in once, on approach (IO; skipped for PRM).
   3. Mobile sticky buy bar — shows after the hero's buy panel scrolls off,
      proxies a click to the real Dawn submit button so the cart path stays
      Dawn's own. */
(function () {
  'use strict';
  var root = document.querySelector('.hc-page');
  if (!root) return;
  var prm = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  // 1 — the bag floats at rest (CSS keyframes on the img) AND tilts with
  // scroll (transform on the WRAPPER, so the two compose instead of
  // fighting — the v1 bug was scroll stealing the float).
  var bagcol = root.querySelector('.hc-bagcol');
  var hero = root.querySelector('.hc-hero');
  if (bagcol && hero && !prm) {
    var ticking = false;
    var update = function () {
      ticking = false;
      var r = hero.getBoundingClientRect();
      var span = r.height + window.innerHeight;
      var progress = Math.min(1, Math.max(0, (window.innerHeight - r.top) / span));
      var deg = (progress - 0.5) * 6; // -3 … +3
      var lift = (progress - 0.5) * -14;
      bagcol.style.transform = 'translateY(' + lift.toFixed(1) + 'px) rotate(' + deg.toFixed(2) + 'deg)';
    };
    window.addEventListener('scroll', function () {
      if (!ticking) { ticking = true; window.requestAnimationFrame(update); }
    }, { passive: true });
    update();
  }

  // 1b — brew method tabs. Progressive: without JS every card stacks;
  // with JS, one tab per card, first selected.
  var brewTabs = root.querySelector('.hc-brew-tabs');
  var brewCards = root.querySelectorAll('.hc-brew-card');
  if (brewTabs && brewCards.length > 1) {
    brewCards.forEach(function (card, i) {
      var name = card.getAttribute('data-method') || ('Recipe ' + (i + 1));
      var tab = document.createElement('button');
      tab.type = 'button';
      tab.className = 'hc-brew-tab';
      tab.setAttribute('role', 'tab');
      tab.setAttribute('aria-selected', i === 0 ? 'true' : 'false');
      // Carry the card's hand-drawn method icon into its tab.
      var icon = card.querySelector('.hc-brew-micon');
      if (icon) {
        var ic = icon.cloneNode(true);
        ic.classList.add('hc-brew-tab-icon');
        tab.appendChild(ic);
      }
      tab.appendChild(document.createTextNode(name));
      tab.addEventListener('click', function () {
        brewCards.forEach(function (c, j) { c.hidden = j !== i; });
        brewTabs.querySelectorAll('.hc-brew-tab').forEach(function (t, j) {
          t.setAttribute('aria-selected', j === i ? 'true' : 'false');
        });
      });
      brewTabs.appendChild(tab);
      card.hidden = i !== 0;
    });
  }

  // 2 — polaroids: animate only when IO is available and motion is allowed;
  // otherwise they simply sit composed (the CSS default).
  var notes = root.querySelector('.hc-notes');
  if (notes && !prm && 'IntersectionObserver' in window) {
    notes.classList.add('hc-animate');
    var io = new IntersectionObserver(function (entries) {
      if (entries.some(function (e) { return e.isIntersecting; })) {
        notes.classList.add('hc-in');
        io.disconnect();
      }
    }, { threshold: 0.25 });
    io.observe(notes);
  }

  // 3 — mobile sticky bar.
  var sticky = root.querySelector('.hc-sticky');
  var buyPanel = root.querySelector('.hc-buy');
  if (sticky && buyPanel && 'IntersectionObserver' in window) {
    var btn = sticky.querySelector('button');
    var submitId = sticky.getAttribute('data-submit-id');
    if (btn && submitId) {
      btn.addEventListener('click', function () {
        var real = document.getElementById(submitId);
        if (real) real.click();
      });
    }
    var io2 = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        sticky.classList.toggle('hc-show', !e.isIntersecting && e.boundingClientRect.top < 0);
      });
    }, { threshold: 0 });
    io2.observe(buyPanel);
  }
})();
